import { render, staticRenderFns } from "./ModalItemsFim.vue?vue&type=template&id=11097030&scoped=true&"
import script from "./ModalItemsFim.vue?vue&type=script&lang=js&"
export * from "./ModalItemsFim.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemsFim.vue?vue&type=style&index=0&id=11097030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11097030",
  null
  
)

export default component.exports